import { DynamicModule, Global, Module } from "@nestjs/common";
import { IConstructableClass } from "@nest/default";

import { IRechargeConfig } from "./lib/types";
import {
  RechargeAccessTokenManager,
} from "./lib/services/RechargeAccessTokenManager";
import {
  RechargeChargesClient,
} from "./lib/services/clients/RechargeChargesClient";
import {
  RechargeDiscountsClient,
} from "./lib/services/clients/RechargeDiscountsClient";
import {
  RechargeCustomersClient,
} from "./lib/services/clients/RechargeCustomersClient";
import {
  RechargeAddressesClient,
} from "./lib/services/clients/RechargeAddressesClient";
import {
  RechargeSubscriptionsClient,
} from "./lib/services/clients/RechargeSubscriptionsClient";
import {
  RechargeOnetimesClient,
} from "./lib/services/clients/RechargeOnetimesClient";
import {
  RechargeOrdersClient,
} from "./lib/services/clients/RechargeOrdersClient";
import {
  RechargePaymentMethodsClient,
} from "./lib/services/clients/RechargePaymentMethodsClient";

export type ConstructableRechargeConfig = IConstructableClass<IRechargeConfig>;
@Global()
@Module({})
export class RechargeClientModule {

  static register(config: ConstructableRechargeConfig): DynamicModule {
    return {
      global: true,
      module: RechargeClientModule,
      providers: [
        {
          provide: RechargeAccessTokenManager,
          inject: [ config ],
          useFactory(c: InstanceType<ConstructableRechargeConfig>) {
            return new RechargeAccessTokenManager(
              c.RECHARGE_BACKEND_API_KEYS,
            );
          },
        },
        {
          provide: RechargeChargesClient,
          inject: [ config, RechargeAccessTokenManager ],
          useFactory(
            c: InstanceType<ConstructableRechargeConfig>,
            keyManager: RechargeAccessTokenManager,
          ) {
            return new RechargeChargesClient(
              keyManager,
              c.RECHARGE_BACKEND_API_URI,
            );
          },
        },
        {
          provide: RechargeCustomersClient,
          inject: [ config, RechargeAccessTokenManager ],
          useFactory(
            c: InstanceType<ConstructableRechargeConfig>,
            keyManager: RechargeAccessTokenManager,
          ) {
            return new RechargeCustomersClient(
              keyManager,
              c.RECHARGE_BACKEND_API_URI,
            );
          },
        },
        {
          provide: RechargeDiscountsClient,
          inject: [ config, RechargeAccessTokenManager ],
          useFactory(
            c: InstanceType<ConstructableRechargeConfig>,
            keyManager: RechargeAccessTokenManager,
          ) {
            return new RechargeDiscountsClient(
              keyManager,
              c.RECHARGE_BACKEND_API_URI,
            );
          },
        },
        {
          provide: RechargeAddressesClient,
          inject: [ config, RechargeAccessTokenManager ],
          useFactory(
            c: InstanceType<ConstructableRechargeConfig>,
            keyManager: RechargeAccessTokenManager,
          ) {
            return new RechargeAddressesClient(
              keyManager,
              c.RECHARGE_BACKEND_API_URI,
            );
          },
        },
        {
          provide: RechargeSubscriptionsClient,
          inject: [ config, RechargeAccessTokenManager ],
          useFactory(
            c: InstanceType<ConstructableRechargeConfig>,
            keyManager: RechargeAccessTokenManager,
          ) {
            return new RechargeSubscriptionsClient(
              keyManager,
              c.RECHARGE_BACKEND_API_URI,
            );
          },
        },
        {
          provide: RechargeOnetimesClient,
          inject: [ config, RechargeAccessTokenManager ],
          useFactory(
            c: InstanceType<ConstructableRechargeConfig>,
            keyManager: RechargeAccessTokenManager,
          ) {
            return new RechargeOnetimesClient(
              keyManager,
              c.RECHARGE_BACKEND_API_URI,
            );
          },
        },
        {
          provide: RechargeOrdersClient,
          inject: [ config, RechargeAccessTokenManager ],
          useFactory(
            c: InstanceType<ConstructableRechargeConfig>,
            keyManager: RechargeAccessTokenManager,
          ) {
            return new RechargeOrdersClient(
              keyManager,
              c.RECHARGE_BACKEND_API_URI,
            );
          },
        },
        {
          provide: RechargePaymentMethodsClient,
          inject: [ config, RechargeAccessTokenManager ],
          useFactory(
            c: InstanceType<ConstructableRechargeConfig>,
            keyManager: RechargeAccessTokenManager,
          ) {
            return new RechargePaymentMethodsClient(
              keyManager,
              c.RECHARGE_BACKEND_API_URI,
            );
          },
        },
      ],
      exports: [
        RechargeAccessTokenManager,
        RechargeChargesClient,
        RechargeCustomersClient,
        RechargeAddressesClient,
        RechargeDiscountsClient,
        RechargeSubscriptionsClient,
        RechargeOnetimesClient,
        RechargeOrdersClient,
        RechargePaymentMethodsClient,
      ],
    };
  }

}
